import React, { useState, useEffect, useCallback } from 'react';

function StatusBadge({ status }) {
  if (status === 'checking') return <span className="badge badge-pending">Checking...</span>;
  if (status === 'healthy') return <span className="badge badge-success">Healthy</span>;
  return <span className="badge badge-error">Unhealthy</span>;
}

export default function HealthCheck() {
  const [checks, setChecks] = useState({
    api: 'checking',
    graphql: 'checking',
  });
  const [lastChecked, setLastChecked] = useState(null);

  const runChecks = useCallback(async () => {
    setChecks({ api: 'checking', graphql: 'checking' });

    const env = window._env_ || {};
    const apiUrl = env.REACT_APP_API_URL || process.env.REACT_APP_API_URL || '/graphql';
    const healthUrl = apiUrl.replace('/graphql', '/health');

    // Check API health endpoint
    try {
      const res = await fetch(healthUrl);
      setChecks((prev) => ({ ...prev, api: res.ok ? 'healthy' : 'unhealthy' }));
    } catch {
      setChecks((prev) => ({ ...prev, api: 'unhealthy' }));
    }

    // Check GraphQL endpoint with a simple introspection
    try {
      const res = await fetch(apiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ query: '{ __typename }' }),
      });
      const json = await res.json();
      setChecks((prev) => ({ ...prev, graphql: json.data ? 'healthy' : 'unhealthy' }));
    } catch {
      setChecks((prev) => ({ ...prev, graphql: 'unhealthy' }));
    }

    setLastChecked(new Date());
  }, []);

  useEffect(() => {
    runChecks();
  }, [runChecks]);

  const allHealthy = Object.values(checks).every((s) => s === 'healthy');
  const anyChecking = Object.values(checks).some((s) => s === 'checking');

  return (
    <div>
      <h2 className="page-title">System Health</h2>

      <div className="card" style={{ textAlign: 'center', padding: '32px 20px' }}>
        <div style={{ fontSize: 48, marginBottom: 8 }}>
          {anyChecking ? '...' : allHealthy ? '200' : '503'}
        </div>
        <div style={{ fontSize: 16, color: '#636e72' }}>
          {anyChecking ? 'Running health checks...' : allHealthy ? 'All systems operational' : 'Some services are degraded'}
        </div>
      </div>

      <div className="card">
        <h3 style={{ marginBottom: 12 }}>Service Status</h3>
        <table className="table">
          <thead>
            <tr>
              <th>Service</th>
              <th>Endpoint</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>API Server</td>
              <td><code>/health</code></td>
              <td><StatusBadge status={checks.api} /></td>
            </tr>
            <tr>
              <td>GraphQL</td>
              <td><code>/graphql</code></td>
              <td><StatusBadge status={checks.graphql} /></td>
            </tr>
          </tbody>
        </table>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 16 }}>
          <span style={{ fontSize: 12, color: '#636e72' }}>
            {lastChecked ? `Last checked: ${lastChecked.toLocaleTimeString()}` : ''}
          </span>
          <button className="btn btn-primary" style={{ padding: '6px 16px', fontSize: 13 }} onClick={runChecks}>
            Re-check
          </button>
        </div>
      </div>
    </div>
  );
}
